<article class="global-theme white content-container">
  <header>
    <app-setpoint-schedules-calendar [schedules]="schedules"></app-setpoint-schedules-calendar>
  </header>
  <main>
    @if (!isLoading && schedules?.length === 0) {
      <app-info-panel>
        <div>There are no upcoming schedules, to create a schedule select a template.</div>
        <div class="mt-1">
          <app-button (click)="navigateTo('templates')" icon="mdi mdi-text-box-multiple-outline" label="Go to templates"></app-button>
        </div>
      </app-info-panel>
    }

    @if (schedules?.length && assetTypes) {
      <app-theme-page-section theme="white" label=" " [toolbar]="[{ icon: 'mdi-plus', label: 'Add a new schedule', tag: 'ADD_SCHEDULE', text: 'Add schedule', tooltipposition: 'bottom' }]" (onToolbarClick)="toolbarClick($event)">
        <table class="table table-hover table-striped">
          <thead>
            <tr>
              <th>Schedule</th>
              <th>Category</th>
              <th>Repeats</th>
              <th>Sites</th>
              <th>Assets</th>
              <th>Process</th>
              <th>Author</th>
            </tr>
          </thead>
          <tbody>
            @for (item of schedules; track item) {
              <tr [routerLink]="['/setpoints', 'schedules', item.id]">
                <td>
                  {{ item.title }} @for (type of item.template.assetTypeIds; track type) {
                  <span>{{ assetTypes[type]?.title || '???' }}</span>
                }
              </td>
              <td>{{ item.template.category.title }}</td>
              <td>{{ item.repeats }}</td>
              <td>{{ item.counts.sites || 'all' }}</td>
              <td>{{ item.counts.assets || 'all' }}</td>
              <td>{{ item.processAt | amDateFormat: 'DD MMM YYYY' }}</td>
              <td>{{ item.createdBy.name }}</td>
              <!--<td><a [routerLink]="['/setpoints','templates',item.template.id,'scheduler', item.id]"><i
            class="mdi mdi-text-box-multiple-outline"></i> template</a></td>-->
            <!--<td [innerHTML]="item.notes"></td>-->
          </tr>
        }
      </tbody>
    </table>
  </app-theme-page-section>
}
</main>
<footer>
  <app-media-carousel [items]="[{ title: 'Setpoint Scheduler', overview: 'setpoint scheduler overview basics', type: 'video', thumbnail: 'https://4d-training.s3.eu-west-1.amazonaws.com/videos/v3/setpoint_scheduler_thumbnail.png', target: 'https://4d-training.s3.eu-west-1.amazonaws.com/videos/v3/setpoint_scheduler.mp4' }]"></app-media-carousel>
</footer>
</article>

@if (isLoading) {
  <app-please-wait></app-please-wait>
}
